export const LEDGER_SUCCESS = "LEDGER_SUCCESS";
export const GET_LEDGER = "GET_LEDGER";
